import ConfirmDelete from 'components/Global/confirmDeleteModel';
import dayjs from 'dayjs';
import { FC, useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { chartOfAccountAction } from 'redux/action/chartOfAccountAction';
import { classOptionsAction } from 'redux/action/classAction';
import { getConfiguration } from 'redux/action/configurationAction';
import {
	customerAccountAction,
	customerOptionsAction,
} from 'redux/action/customerAction';
import { getEmployeeAction } from 'redux/action/employeeAction';
import { payPeriodOptionsAction } from 'redux/action/payPeriodAction';
import { deleteTimeLogAction } from 'redux/action/timeLogsAction';
import { AppDispatch } from 'redux/store';
import DynamicTable from '../Table';
import styles from './index.module.scss';
import { TimeLogsProps } from './types';
import { getCustomRulesAction } from 'redux/action/customRuleAction';

// For time log section
const TimeLogs: FC<TimeLogsProps> = (props) => {
	// Inits
	const {
		timeLogs,
		updateTimeLogHandler,
		disableHandler,
		saveAddedItemHandler,
		updateSavedTimeLog,
		deleteTimeLogHandler,
		splitTimeLogHandler,
		error,
		cancelSplitHandler,
		saveSplitTimeLogHandler,
		updateSplitActivityHandler,
		updateSplitActivityOnBlur,
		splitDisableHandler,
		subSplitHandler,
		removeSubSplitHandler,
		// hoursUnder,
		openTables,
		setOpenTables,
		onChangePayPeriod,
		selectedPayPeriod,
		onChangeFilter,
		onChangeSearch,
		onSortChange,
		onChangeScroll,
		onClearFilter,
		filterValue,
		searchValue,
		sortHandler,
		currentPage,
		sortName,
		sortValue,
		editSplitTimeLogHandler,
		onChangeIsAccountClosed,
		initialCall,
		isCreateTimeSheetPermission,
		isUpdateTimeSheetPermission,
		timeSheetData,
		openValidateTimeSheetModalHandler,
	} = props;

	const [isModalOpen, setIsModalOpen] = useState(false);
	const [editSelectedTimeLog, setEditSelectedTimeLog] = useState<any>();
	const [isInViewPort, setIsInViewPort] = useState<boolean>(false);

	const tableRef = useRef<HTMLDivElement>(null);
	const { count, deleteLoader } = useSelector((state: any) => state.timeLogs);
	const dispatch = useDispatch<AppDispatch>();

	const [selectedYear, setSelectedYear] = useState<any>(
		dayjs(new Date()).year()
	);

	const { selectedCompanyDetails } = useSelector(
		(state: any) => state.companies
	);

	const onChangeYear = (value: string | null) => {
		setSelectedYear(value);
	};

	// Perform Filter
	const performFilterHandler = (data: any, value: any) => {
		onChangeFilter && onChangeFilter(data, value);
	};

	const clearFilter = () => {
		onClearFilter && onClearFilter();
	};

	// For perform the search operation
	const performSearchHandler = (e: any) => {
		// const { value } = event.target;
		// setSearchValue(value.trimStart());
		onChangeSearch && onChangeSearch(e);
	};

	// useEffect(() => {
	// 	if (applySearch) {
	// 		performSearchHandler(debounceSearchValue);
	// 	}
	// }, [debounceSearchValue]);

	// for pagination

	//   For open the model
	const showModal = () => {
		setIsModalOpen(true);
	};

	// For the run initial call from use effect
	const initialFunction = () => {
		dispatch(classOptionsAction());
		// dispatch(classAction());
		dispatch(customerOptionsAction());
		dispatch(chartOfAccountAction());
		dispatch(customerAccountAction());
		dispatch(getEmployeeAction());
		dispatch(payPeriodOptionsAction());
		const query: any = {
			status: 'Active',
		};
		dispatch(getCustomRulesAction(query));

	};

	//adding body to scroll to table body Infinite scroll
	const scrollHandler = useCallback((event: any) => {
		const { scrollTop, scrollHeight, clientHeight } = event.target;
		// If scrolled to bottom (with a small threshold)
		if (scrollTop + clientHeight >= scrollHeight - 10) {
			setIsInViewPort(true);
		} else {
			setIsInViewPort(false);
		}
	}, []);

	// useEffect(() => {
	// 	if (tableRef.current) {
	// 		const tableBody = tableRef.current
	// 			? tableRef.current?.querySelector('.ant-table-body')
	// 			: null;
	// 		// if (tableBody) {
	// 		tableBody?.addEventListener('scroll', scrollHandler);
	// 		return () => tableBody?.removeEventListener('scroll', scrollHandler);
	// 		// }
	// 	}
	// }, [tableRef.current]);

	useEffect(() => {
		const tableBody = document.querySelector('.ant-table-body');
		tableBody?.addEventListener('scroll', scrollHandler);
		return () => {
			// Remove scroll event listener when component unmounts
			tableBody?.removeEventListener('scroll', scrollHandler);
		};
	}, [timeLogs, scrollHandler]);

	// For perform the sorting operation
	const performSortHandler = (name: string, value: string) => {
		onSortChange && onSortChange(name, value);
	};

	useEffect(() => {
		if (isInViewPort && timeLogs.length < count) {
			onChangeScroll();
		}
	}, [isInViewPort]);

	//   For cancel operation
	const handleCancel = () => {
		setIsModalOpen(false);
	};

	//   For conform operation
	const handleOk = () => {
		setIsModalOpen(false);
	};

	// For actual delete of the time log
	const deleteHandler = async () => {
		await dispatch(
			deleteTimeLogAction({ timeActivityId: editSelectedTimeLog.id })
		);
		setIsModalOpen(false);
		deleteTimeLogHandler(editSelectedTimeLog);
	};

	// const getTimeLogOnHoursChange = () => {
	// 	const query = {
	// 		page: 1,
	// 		limit: 10,
	// 		search: searchValue,
	// 		...filterValue,
	// 		...dateRangeDate,
	// 		isOverHours: hoursUnder,
	// 		year: selectedYear,
	// 	};
	// 	dispatch(getTimeLogs(query));
	// };

	useEffect(() => {
		initialFunction();
	}, []);

	useEffect(() => {
		initialFunction();
		dispatch(
			getConfiguration({
				payPeriodId: selectedPayPeriod,
			})
		);
	}, [selectedCompanyDetails, selectedPayPeriod]);

	// useEffect(() => {
	// 	if (hoursUnder) {
	// 		getTimeLogOnHoursChange();
	// 	}
	// }, [hoursUnder]);

	// JSX
	return (
		<div className={styles['time-logs']}>
			<div className={styles['time-logs__wrapper']}>
				<div>
					<DynamicTable
						selectedPayPeriod={selectedPayPeriod}
						openTables={openTables}
						setOpenTables={setOpenTables}
						userDataSource={timeLogs}
						currentPage={currentPage}
						totalRecords={10}
						totalCount={count}
						performSearchHandler={performSearchHandler}
						searchValue={searchValue}
						onChangeSearchValue={(value: any) => {
							performSearchHandler(value);
						}}
						showModal={showModal}
						setEditSelectedTimeLog={setEditSelectedTimeLog}
						tableRef={tableRef}
						performSortHandler={performSortHandler}
						performFilterHandler={performFilterHandler}
						filterValue={filterValue}
						sortHandler={sortHandler}
						updateTimeLogHandler={updateTimeLogHandler}
						disableHandler={disableHandler}
						splitDisableHandler={splitDisableHandler}
						editSplitTimeLogHandler={editSplitTimeLogHandler}
						saveAddedItemHandler={saveAddedItemHandler}
						updateSavedTimeLog={updateSavedTimeLog}
						error={error}
						splitTimeLogHandler={splitTimeLogHandler}
						cancelSplitHandler={cancelSplitHandler}
						saveSplitTimeLogHandler={saveSplitTimeLogHandler}
						updateSplitActivityHandler={updateSplitActivityHandler}
						updateSplitActivityOnBlur={updateSplitActivityOnBlur}
						subSplitHandler={subSplitHandler}
						removeSubSplitHandler={removeSubSplitHandler}
						onResetFilter={() => {
							//
						}}
						clearFilter={clearFilter}
						onChangeYear={onChangeYear}
						selectedYear={selectedYear}
						onChangePayPeriod={(payPeriod: string | null) => {
							onChangePayPeriod && onChangePayPeriod(payPeriod);
						}}
						sortName={sortName}
						sortValue={sortValue}
						onChangeIsAccountClosed={(flag: boolean) => {
							onChangeIsAccountClosed(flag);
						}}
						initialCall={initialCall}
						isCreateTimeSheetPermission={isCreateTimeSheetPermission}
						isUpdateTimeSheetPermission={isUpdateTimeSheetPermission}
						timeSheetData={timeSheetData}
						openValidateTimeSheetModalHandler={
							openValidateTimeSheetModalHandler
						}
					/>
				</div>
				<ConfirmDelete
					handleCancel={handleCancel}
					handleOk={handleOk}
					isModalOpen={isModalOpen}
					deleteHandler={deleteHandler}
					isLoading={deleteLoader}
				/>
			</div>
		</div>
	);
};

export default TimeLogs;
